import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { A11yModule } from '@angular/cdk/a11y';
import { SkillDeleteRequest } from '../skill-detail/skill-detail.component';
import { SkillIconComponent } from '../skill-icon/skill-icon.component';
import { hasText } from '../skill-catalog-model';

@Component({
  selector: 'app-skill-delete-modal',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, TranslatePipe, A11yModule, SkillIconComponent],
  templateUrl: './skill-delete-modal.component.html',
  styleUrl: './skill-delete-modal.component.scss',
})
export class SkillDeleteModalComponent {
  @Input({ required: true }) request!: SkillDeleteRequest;
  @Input() deleting = false;
  @Output() closed = new EventEmitter<void>();
  @Output() confirmed = new EventEmitter<void>();
  @Output() goToSimilar = new EventEmitter<void>();

  acknowledged = false;

  get used(): boolean {
    return this.request.tasks > 0;
  }

  get canDelete(): boolean {
    return (!this.used || this.acknowledged) && !this.deleting;
  }

  get showEnglishName(): boolean {
    const skill = this.request.skill;
    return (
      hasText(skill.faehigkeitEn) &&
      skill.faehigkeitEn!.trim() !== skill.faehigkeit?.trim()
    );
  }

  get tasksKey(): string {
    return this.request.tasks === 1
      ? 'skillManagement.delete.taskOne'
      : 'skillManagement.delete.tasks';
  }

  get consultantsKey(): string {
    return this.request.consultants === 1
      ? 'skillManagement.delete.consultantOne'
      : 'skillManagement.delete.consultants';
  }
}
